import {
  Badge,
  Box,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

interface Props {
  title: string;
  date: string;
  image: string;
  onClick?: () => void;
}

export const WhatsNextBanner = ({ title, date, image, onClick }: Props) => (
  <ContentBlock>
    <Box
      component={onClick ? 'button' : 'div'}
      type={onClick ? 'button' : undefined}
      cursor={onClick ? 'pointer' : undefined}
      onClick={onClick}
      display="block"
      width="full"
      padding="none"
      borderRadius="large"
      style={
        onClick
          ? {
              appearance: 'none',
              background: 'transparent',
              border: 'none',
              textAlign: 'left',
            }
          : undefined
      }
    >
      <Box
        background="positiveLight"
        paddingY="gutter"
        paddingX="small"
        borderRadius="large"
      >
        <Box
          style={{
            paddingLeft: '160px',
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: '20px center',
          }}
        >
          <Stack space="small">
            <Badge tone="caution" weight="strong">
              What&apos;s next?
            </Badge>
            <Heading level="2">
              <span style={{ fontSize: '28px', fontWeight: 600 }}>{title}</span>
            </Heading>
            <Text>{date}</Text>
          </Stack>
        </Box>
      </Box>
    </Box>
  </ContentBlock>
);
